/**
 * URLs de exibição de imagens 360°.
 *
 * preview  → cards, grids, capa (somente thumbnail real)
 * panorama → Viewer / Pannellum
 *
 * Documentos legados (sem thumbnail persistido) não usam o panorama 8K
 * como fallback silencioso na grid.
 */

/**
 * Thumbnail real: previewUrl distinto do panorama e path de storage presente.
 *
 * @param {{ previewUrl?: string, originalUrl?: string, previewStoragePath?: string } | null | undefined} image
 * @returns {boolean}
 */
export function isRealImageThumbnail(image) {
  const previewUrl = String(image?.previewUrl || "").trim();
  const originalUrl = String(image?.originalUrl || "").trim();
  const previewStoragePath = String(image?.previewStoragePath || "").trim();

  if (!previewUrl) {
    return false;
  }
  if (previewUrl === originalUrl) {
    return false;
  }
  return Boolean(previewStoragePath);
}

/**
 * Origem visual do card. Nunca retorna `legacy-original` — o panorama
 * full-res não é usado como miniatura.
 *
 * @param {{ previewUrl?: string, originalUrl?: string, previewStoragePath?: string } | null | undefined} image
 * @returns {"thumbnail" | "placeholder"}
 */
export function getImageCardSource(image) {
  return isRealImageThumbnail(image) ? "thumbnail" : "placeholder";
}

/**
 * URL do thumbnail para cards/capa. Vazio quando o registro é legado.
 *
 * @param {{ previewUrl?: string, originalUrl?: string, previewStoragePath?: string } | null | undefined} image
 * @returns {string}
 */
export function getImagePreviewUrl(image) {
  return isRealImageThumbnail(image) ? String(image.previewUrl).trim() : "";
}

/**
 * Documento tem alguma URL persistida (panorama e/ou preview).
 *
 * @param {{ originalUrl?: string, previewUrl?: string } | null | undefined} image
 * @returns {boolean}
 */
export function hasPersistedImageUrl(image) {
  return Boolean(
    String(image?.originalUrl || "").trim() ||
      String(image?.previewUrl || "").trim(),
  );
}

/**
 * URL do panorama para o viewer 360°. Nunca prefere o thumbnail.
 *
 * @param {{ originalUrl?: string, previewUrl?: string } | null | undefined} image
 * @returns {string}
 */
export function getImagePanoramaUrl(image) {
  return image?.originalUrl || image?.previewUrl || "";
}

/**
 * @param {{ previewUrl?: string, originalUrl?: string } | null | undefined} image
 * @param {string} [coverImage]
 * @returns {boolean}
 */
export function imageMatchesCover(image, coverImage) {
  const cover = String(coverImage || "").trim();
  if (!cover || !image) {
    return false;
  }

  return cover === image.previewUrl || cover === image.originalUrl;
}
